import { useState } from 'react'

export function useContentHeader() {
    const [openedChooseCinema, setOpenedChooseCinema] = useState(false)
    const [openedMenu, setOpenedMenu] = useState(false)

    const toggleChooseCineama = () => {
        setOpenedChooseCinema((prevValue) => !prevValue)
        setOpenedMenu(false)
    }

    const toggleMenu = () => {
        setOpenedChooseCinema(false)
        setOpenedMenu((prevValue) => !prevValue)
    }

    const handleClose = () => {
        setOpenedChooseCinema(false)
        setOpenedMenu(false)
    }

    const handleClickProgram = () => {
        setOpenedChooseCinema(false)
        setOpenedMenu(false)
        const referer = localStorage.getItem('referer')
        window.location.href = referer
    }

    return { openedChooseCinema, openedMenu, toggleChooseCineama, toggleMenu, handleClose, handleClickProgram }
}
